import React from 'react';
import { Navigate, ToolbarProps, Views } from 'react-big-calendar';
import { startOfWeek, endOfWeek, format } from 'date-fns';
import { Icon } from 'src/components/Icon';
import { Button } from 'src/components/Button';

import styles from './styles.module.css';

export const CustomToolbar: React.FC<ToolbarProps> = ({
  date,
  view,
  onNavigate,
  onView,
}) => {
  const goToBack = () => {
    onNavigate(Navigate.PREVIOUS);
  };

  const goToNext = () => {
    onNavigate(Navigate.NEXT);
  };

  const goToCurrent = () => {
    onNavigate(Navigate.TODAY);
  };

  const currentDate = new Date();
  const isCurrentMonth =
    date.getMonth() === currentDate.getMonth() &&
    date.getFullYear() === currentDate.getFullYear();

  const getTitle = () => {
    switch (view) {
      case Views.MONTH:
        return date.toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric',
        });
      case Views.WEEK:
        const weekStart = startOfWeek(date, { weekStartsOn: 0 });
        const weekEnd = endOfWeek(date, { weekStartsOn: 0 });
        return `${format(weekStart, 'MMMM d')} - ${format(weekEnd, 'd, yyyy')}`;
      case Views.DAY:
        return format(date, 'MMMM d, yyyy');
      default:
        return date.toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric',
        });
    }
  };

  return (
    <div className={styles.toolbar}>
      <div className={styles.toolbarLeft}>
        <Button type="button" variant="outline" size="sm" onClick={goToBack}>
          <Icon className={styles.icon} name="arrowLeft" />
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={goToNext}>
          <Icon name="arrowRight" />
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={goToCurrent}
          className={isCurrentMonth ? styles.active : ''}
        >
          Today
        </Button>
        <h2 className={styles.title}>{getTitle()}</h2>
      </div>

      <div className={styles.toolbarRight}>
        <Button
          type="button"
          variant={view === Views.MONTH ? 'filled' : 'outline'}
          size="sm"
          onClick={() => onView(Views.MONTH)}
        >
          Month
        </Button>
        <Button
          type="button"
          variant={view === Views.WEEK ? 'filled' : 'outline'}
          size="sm"
          onClick={() => onView(Views.WEEK)}
        >
          Week
        </Button>
        <Button
          type="button"
          variant={view === Views.DAY ? 'filled' : 'outline'}
          size="sm"
          onClick={() => onView(Views.DAY)}
        >
          Day
        </Button>
      </div>
    </div>
  );
};
